import { api } from '../config/api';
import {
  ACTIVE_LIMIT,
  PATHS,
  dropFromPayload,
  normalizeList,
} from '../components/giftDropShape';

// ---- Galaxy gift drops (the Challenges page) ----
// The contract — paths, fields, error codes — lives in components/giftDropShape.js.

function query(params) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined && value !== '') search.set(key, String(value));
  }
  const text = search.toString();
  return text ? `?${text}` : '';
}

/**
 * The brand's chests, newest first.
 * @param {string} brandId
 * @param {{ status?: string, limit?: number, before?: string|null }} [params]
 */
export async function fetchGiftDrops(brandId, { status, limit, before } = {}) {
  const payload = await api(`${PATHS.list(brandId)}${query({ status, limit, before })}`);
  return normalizeList(payload, { limit });
}

export const fetchActiveGiftDrops = (brandId) =>
  fetchGiftDrops(brandId, { status: 'active', limit: ACTIVE_LIMIT });

/**
 * Drop a chest into the galaxy. No lifetime (it crosses rim to rim).
 * followersOnly: only the brand's followers can catch it. productIds (v2.2):
 * the brand's own products the catcher gets free (qty 1 each, free shipping
 * paid by the brand) — sent only when there are any, then with
 * freeShippingAccepted. rewardType stays null: the server records the reward.
 */
export async function createGiftDrop(brandId, { note, followersOnly = false, productIds = [], freeShippingAccepted = false } = {}) {
  const body = { note: note?.trim() || null, followersOnly: Boolean(followersOnly), rewardType: null };
  const ids = [...new Set((productIds || []).map(String))];
  if (ids.length) {
    body.productIds = ids;
    body.freeShippingAccepted = freeShippingAccepted === true;
  }
  const payload = await api(PATHS.create(brandId), { method: 'POST', body });
  return { drop: dropFromPayload(payload), serverNowMs: payload?.serverNowMs ?? null };
}

export async function cancelGiftDrop(brandId, id) {
  const payload = await api(PATHS.cancel(brandId, id), { method: 'POST', body: {} });
  return dropFromPayload(payload);
}
